module.exports = __webpack_public_path__ + "img/angle-right-solid.5123a8c5.svg";